import "react-app-polyfill/ie11";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
//import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { Provider } from "react-redux";
import store from "./redux/store"


ReactDOM.render(
    <BrowserRouter>
        <ScrollToTop>
           <Provider store={store}>
           <App></App>
           </Provider>
        </ScrollToTop>
    </BrowserRouter>,
    document.getElementById("root")
);

// Register service worker for background location tracking
window.addEventListener("load", () => {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.register("/service-worker.js").then((registration) => {
            console.log("Service Worker registered:", registration.scope);
        }).catch((error) => {
            console.log("Service Worker registration failed:", error.message);
        });
    }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
